import { render, staticRenderFns } from "./TrainerTile.vue?vue&type=template&id=5b7e32aa"
import script from "./TrainerTile.vue?vue&type=script&lang=js"
export * from "./TrainerTile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports